export default __webpack_public_path__ + "5c96b15ec979f0a409d9abdb549666a1.svg";